module.exports = __webpack_public_path__ + "img/prodmanagementTime.f6bc580a.svg";